import API from "../Services/API";
import Model from "./Model";
import State from "./State";

const usePricingCategories = (alwaysRefresh = false) => {
    return Model({
        stateKey: 'pricing-categories',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/pricing/categories`),
        suppressLoadingError: true,
        returnDataKey: 'categories',
        saveAdditionalData: (data) => {
            data.forEach(cat => {
                State.putIfNotExists(['pricing-category', cat.id], cat);
            });
        },
        registerAdditionalMethods: (opts) => {
            return {
                addCategory: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/pricing/categories', data),
                        'Pricing category added',
                        true,
                    );
                },
                editCategory: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/pricing/categories/${data.pricingCategoryId}`, data),
                        'Pricing category updated',
                        true,
                    );
                },
                deleteCategory: (categoryId) => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/pricing/categories/${categoryId}`),
                        'Pricing category deleted',
                        true,
                    );
                },
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading pricing categories.',
    })
}

const usePricingCategory = (categoryId, alwaysRefresh = false) => {
    return Model({
        stateKey: ['pricing-category', categoryId],
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/pricing/categories/${categoryId}`),
        suppressLoadingError: true,
        returnDataKey: 'category',
        registerAdditionalMethods: (opts) => {
            return {
                addItem: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/pricing/categories/${categoryId}/items`, data),
                        'Pricing item added',
                        true,
                    );
                },
                editItem: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/pricing/categories/${categoryId}/items/${data.id}`, data),
                        'Pricing item updated',
                        true,
                    );
                },
                deleteItem: (id) => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/pricing/categories/${categoryId}/items/${id}`),
                        'Pricing item deleted',
                        true,
                    );
                },
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading the pricing category.',
    })
}

export {
    usePricingCategories,
    usePricingCategory,
}
